import React, { Component }         from 'react';

import ReadSign from 'components/chatBot/messageTypes/messageComponents/readSign';

class Message extends Component {
    constructor(props) {
        super(props);
        this.state = {
            setWidth: {
                shouldUpdate: true,
                messageWidth: null,
                messageHeight: null
            }
        };

        this.setWidth = this.setWidth.bind(this);
    }

    componentDidUpdate(){
        if(this.state.setWidth.shouldUpdate){
            this.setWidth();
        }
    }

    componentDidMount() {
        let setWidth = this.state.setWidth;
        setWidth.messageWidth = this.refs['messageText'].offsetWidth + (this.props.shortSellDescriptionDesktopExp ? 45 : 0);
        setWidth.messageHeight = this.refs['messageText'].offsetHeight;
        this.setState(setWidth);
        // this.props.chatUpdated(this.props.message, this.refs.message);
        if(parseInt(this.props.message.direction) === 2) {
            this.props.avatarUpdate('message outgoing last-message');
        }
    }

    setWidth() {
        let setWidth = this.state.setWidth;
        if(setWidth.messageWidth >= 10 && this.refs['messageText'].offsetHeight === setWidth.messageHeight) {
            setWidth.messageWidth -= 5;
            this.setState({setWidth});
        }
        else {
            setWidth.messageWidth += 5;
            setWidth.shouldUpdate = false;
            this.setState({setWidth});
        }
        if(this.props.message.imageHeight){
            setWidth.messageHeight = this.props.message.imageHeight;
            this.setState({setWidth});
        }
    }

    render(){
        let className = "message message-text fade-in" + (parseInt(this.props.message.direction) === 1 ? ' incoming' : ' outgoing') + (this.props.lastMessage ? ' last-message' : '');
        let messageStyle = {};
        if(this.state.messageWidth != null){
            messageStyle = {width: this.state.setWidth.messageWidth + 'px'};
            if(this.props.avatarTestMode){
                className += " avatar-message";
            }
        }
        return (
            <div ref="message" className={className} style={messageStyle}>
                <span ref="messageText" dangerouslySetInnerHTML={ {__html: this.props.message.text} } />
                <div className="message-time" dangerouslySetInnerHTML={ {__html: 'Today '+this.props.message.time} } />
                {
                    (()=>{
                        if(parseInt(this.props.message.direction) === 2) {
                            return(<ReadSign />)
                        }
                    })()
                }
            </div>
        );
    }
}

export default Message;